export default __webpack_public_path__ + "static/pave-5026c3573fb7953ae236634c828f068a.jpg";